/** @jsxImportSource @emotion/react */
import { jsx, css, keyframes } from "@emotion/react";
import {
  Grid,
  Box,
  TextField,
  Badge,
  Typography,
  Dialog,
  Button,
  Paper,
  Divider,
  alertTitleClasses,
  SwipeableDrawer,
} from "@mui/material";
import BottomButton from "./BottomButton";
import BottomMenu from "./BottomMenu";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { ko } from "date-fns/locale";
import PickersDay from "@mui/lab/PickersDay";
import moment from "moment";
import { useState, forwardRef, useEffect, useRef } from "react";
import pr from "../lib/pr";
// import Calendar from 'react-calendar'
// import 'react-calendar/dist/Calendar.css';
import styled from "styled-components";
import { LinearProgress } from "@mui/material";
// import ProgressBar from 'react-bootstrap/ProgressBar'
// import ProgressBar from '@ramonak/react-progress-bar';
import { styled as mStyled } from "@mui/material/styles";
import { linearProgressClasses } from "@mui/material";
import { withStyles } from "@mui/material";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import { red } from "@mui/material/colors";
import ClearIcon from "@mui/icons-material/Clear";
import { Link, useHistory } from "react-router-dom";
// import AnimatedNumbers from 'react-animated-numbers';
import { TurnOverSequence } from "react-count-number-turnover";
import CountUp from "react-countup";
// import img from '../img/calendar_back.jpg';
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import KeyIcon from "@mui/icons-material/Key";
import axios from "axios";
import { isSameDay, isDate, isEqual, getDate, nextFriday } from "date-fns";
import KeyOffIcon from "@mui/icons-material/KeyOff";
import { loginState, configState } from "../lib/State";
// global daum
import { Component } from "react";
import HomeCalendar from "./HomeCalendar";
import send_webview_data from "../lib/send_webview_data";
import EventCoupon from "./EventCoupon";
import HomeHrSync from "./HomeHrSync"; // 출석프리퀀시 누적
import { useSetRecoilState } from "recoil";
import HomeLevel from "./HomeLevel";
import HomeClassPoint from "./HomeClassPoint";
import HomeCash from "./HomeCash";
import Carousel from "react-multi-carousel";
import WhatsNew from "./WhatsNew";
import HomeCountClassCoupon from "./HomeCountClassCoupon";
import HomeCountPTCoupon from "./HomeCountPTCoupon";
import HomeCountPassCoupon from "./HomeCountPassCoupon";
import HomeCountFrequency from "./HomeCountFrequency";
import HomeCountHeart from "./HomeCountHeart";
import HomeCountCash from "./HomeCountCash";
import HomeNotice from "./HomeNotice";
import { Swiper, SwiperSlide, FreeMode } from "swiper/react";
// import { FreeMode } from 'swiper';
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { ReactComponent as QuestionIcon } from "../assets/question.svg";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";
import HomeDoor from "./HomeDoor";
import HomeCountCalorie from "./HomeCountCalorie";
import HomeCalorie from "./HomeCalorie";
import HomeMemberLevel from "./HomeMemberLevel";
import HomeCalorieGage from "./HomeCalorieGage";
import HomeHeartPoint from "./HomeHeartPoint";
import Swal from "sweetalert2";
import HomeFooter from "./HomeFooter";
import EventPopup from "./EventPopup";
import HomeCalorieGageBoostUp from "./HomeCalorieGageBoostUp";
import ResearchInfo from "./ResearchInfo";

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 1.3,
    sidesToSlide: 2,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1.3,
    sidesToSlide: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1.3,
    sidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1.3,
    sidesToSlide: 2,
  },
};

const theme = createTheme({
  components: {
    MuiPickerStaticWrapper: {
      styleOverrides: {
        root: {
          // backgroundImage: `url(${img})`,
          // backgroundSize: "cover",
          // backgroundPosition: "center",
          minWidth: "320px",
          maxWidth: "320px",
          width: "100%",
          maxHeight: "250px",
          height: "100%",
          marginLeft: "20px",
          // color: 'white',
        },
      },
    },
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          maxWidth: "300px",
          width: "100%",
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          // color: 'white'
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          maxWidth: "29px",
          margin: 0,
          // background: 'yellow',
          height: "10px",
        },
      },
    },
    // PrivatePickersFadeTransitionGroup: {
    //   styleOverrides: {
    //     root: {
    //       fontSize: '10px',
    //     },
    //   },
    // },
    MuiSvgIcon: {
      styleOverrides: {
        fontSizeMedium: {
          // color: 'white',
        },
      },
    },
  },
});

const typoTheme = createTheme({
  typography: {
    fontFamily: "BebasNeue",
  },
});

const CouponLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    background: "#E0E0E0",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    background: "#de3a7b",
  },
}));

const MemberLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    background: "#E0E0E0",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    background: "#de3a7b",
  },
}));

function Home(props) {
  // 변수선언
  const history = useHistory();
  const [tabValue, setTabValue] = useState("1");
  const [loaded, setLoaded] = useState(false);
  const [login, setLogin] = useState(loginState);
  const token = localStorage.getItem("token");
  const [date, setDate] = useState();
  const [highlightedDays, setHighlightedDays] = useState([1, 2, 15, 26]);
  //minDate 작년, maxDate 내년 moment로 연산
  // const minDate = moment(date).add(-1, 'years');
  // const maxDate = moment(date).add(+1, 'years');
  const minDate = new Date(moment().add(-1, "years"));
  const maxDate = new Date(moment().add(+1, "years"));
  const testDate = new Date();
  const locale = "ko";
  const [coupon, setCoupon] = useState(false);
  // const [buttonLarge, setButtonLarge] = useState(true);
  const [readyOpen, setReadyOpen] = useState(false);
  const [count, setCount] = useState("");
  const cid = get_cid();
  const center = get_center(cid);
  const [membership, setMembership] = useState("");
  const [openMember, setOpenMember] = useState(false);
  const [showPassCoupon, setShowPassCoupon] = useState(null);

  var d = moment(date).format("D");

  const clickReadyClose = () => {
    setReadyOpen(false);
  };

  // 토큰 로그인 (로그인 연장)
  const token_login = async () => {
    await axios.post(configState.api + "/gympass/token_login", {
      cid: cid,
      token: token,
    });
    get_session();
  };

  const get_session = () => {
    axios
      .post(configState.api + "/gympass/get_session", {
        token: token,
        cid: cid,
      })
      .then((result) => {
        if (result.data.mcd !== "" && result.data.success === 1) {
          setLogin({ mcd: result.data.mcd, level: result.data.level });
        }
        setLoaded(true);
      });
  };
  useEffect(() => {
    load_data();
  }, [loaded]);

  // 센터별 패스쿠폰 사용유무
  useEffect(async () => {
    if (cid) {
      let result = await axios.post(
        configState.api + "/gympass/get_basecode_text",
        {
          cid: cid,
          gubun: "use_pass_coupon",
        },
      );
      if (result.data.ret === "Y") {
        setShowPassCoupon(true);
      }
    }
  }, [cid]);

  const load_data = async () => {
    let postData = {
      token: token,
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(
      configState.api + "/gympass/home_count_pass",
      postData,
    );
    setCount(result.data.count);
  };

  const load_membership = async () => {
    let postData = {
      token: token,
      mcd: login.mcd,
      level: login.level,
      cid: cid,
    };
    let result = await axios.post(
      configState.api + "/gympass/home_membership",
      postData,
    );
    setMembership(result.data.count);
  };

  const openCoupon = () => {
    setCoupon(true);
  };
  const closeCoupon = () => {
    setCoupon(false);
  };

  // 가상데이타
  const [dt1, setDt1] = useState([]); // 출석현황
  const [dt2, setDt2] = useState([]); // 예약현황
  const reserve_data = [1, 10, 3, 4, 6];
  const present_data = [9, 10];

  const get_reservation_data = async () => {
    // .. DB
    setDt1(reserve_data);
  };

  useEffect(() => {
    get_reservation_data();
  }, []);

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  // const handleScroll = () => {
  //   if (window.scrollY > 5) {
  //     setButtonLarge(false);
  //     return;
  //   }
  //   if (window.scrollY <= 5) {
  //     setButtonLarge(true);
  //     return;
  //   }
  // };

  const atheme = useTheme();
  // const animatedLong = css`
  //   animation: ${buttonLong} 1s ease-out;
  //   height: 50px;
  //   width: 150px;
  //   border-radius: 50px;
  //   overflow: hidden;
  //   white-space: nowrap;
  // `;

  // const animatedShort = css`
  //   animation: ${buttonShort} 1s ease-in;
  //   min-width: 0;
  //   width: 50px;
  //   height: 50px;
  //   overflow: hidden;
  //   border-radius: 50px;
  //   white-space: nowrap;
  //   /* opacity: 1; */
  //   /* width: 0; */
  // `

  const buttonTheme = createTheme({
    transitions: {
      // easing: {
      //   easeInOut: ''
      // },
      // duration: {
      //   shortest: ''
      // },
      transition: {
        transitionDelay: "0.5s",
      },
    },
  });

  // 프로그램 시작
  useEffect(() => {
    token_login();
  }, []);

  // 앱에 로그인 전달
  useEffect(() => {
    if (login.mcd) {
      send_webview_data({ id: "mcd", value: login.mcd, cid: cid });
    }
  }, [login.mcd]);

  const [ptPoint, setPtPoint] = useState(false);

  const getData = (ptPoint) => {
    setPtPoint(ptPoint);
  };

  // 클래스 쿠폰 수
  const homeClassCoupontRef = useRef();
  const homeClassCouponReload = () => {
    homeClassCoupontRef.current.reload();
  };

  const homePTCoupontRef = useRef();
  const homePTCouponReload = () => {
    homePTCoupontRef.current.reload();
  };

  const homePassCouponRef = useRef();
  const homePassCouponReload = () => {
    homePassCouponRef.current.reload();
  };

  // 심박포인트 팝업
  // const homeHeartRef = useRef();
  // const heartPointClick = () => {
  //   if (login.mcd !== "") {
  //     homeHeartRef.current.open();
  //   }
  // };

  // 출석포인트 팝업
  const homeClassRef = useRef();
  const frequencyClick = () => {
    if (login.mcd !== "") {
      homeClassRef.current.open();
    }
  };

  const WhatsNewRef = useRef();
  const WhatsNewClick = () => {
    WhatsNewRef.current.open();
  };

  // 캐시 팝업
  const homeCashRef = useRef();
  const cashClick = () => {
    if (login.mcd !== "") {
      homeCashRef.current.open();
    }
  };

  // 칼로리 팝업
  const homeCalorieRef = useRef();
  const caloriePointClick = () => {
    if (login.mcd !== "") {
      homeCalorieRef.current.open();
    }
  };

  // 메세지 웹 > 엡
  useEffect(() => {
    window.addEventListener("message", (res) => {
      let { k, v } = res.data;
      if (k === "unread_count") {
        // 안읽은 메시지 업데이트
        setCount(v);
      }
    });
    // 안읽은 메시지 요청
    send_webview_data({ id: "unread_count", value: "request", cid: cid });
  }, []);

  useEffect(() => {
    if (login.mcd !== "") {
      load_membership();
    }
  }, [login.mcd]);

  useEffect(() => {
    if (cid !== "XXXXX" /*줌*/) return;
    document.body.style.zoom = 2.5;
  }, []);

  return !center ? (
    <div className="w-scree h-screen flex justify-center items-center">
      접속할 수 없는 센터 입니다.
    </div>
  ) : (
    <Grid container width="100%" direction="column">
      <EventPopup cid={cid} WhatsNewClick={WhatsNewClick} />
      <Dialog
        fullScreen
        open={openMember}
        onClose={() => setOpenMember(false)}
        sx={{ zIndex: 300 }}
      >
        <Box
          sx={{
            width: "90%",
            textAlign: "left",
            padding: "30px 0 10px 10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <img
            src="/img/back_button_black.png"
            onClick={() => setOpenMember(false)}
          />
          <Box
            sx={{
              margin: "25px 0 0 10px",
              fontSize: "22px",
              fontWeight: "bold",
            }}
          >
            멤버십 혜택
          </Box>
        </Box>
        <Divider />
        <HomeMemberLevel login={login} />
      </Dialog>

      {/* <Button onClick={()=>send({id:'mcd', value:'070809'})}>SEND</Button> */}

      {/* HR 회원싱크 */}
      <HomeHrSync login={login} />

      {/* 출석포인트 팝업 */}
      <HomeClassPoint ref={homeClassRef} login={login} />

      {/* 캐시 팝업 */}
      <HomeCash ref={homeCashRef} login={login} />

      {/* 칼로리 팝업 */}
      <HomeCalorie ref={homeCalorieRef} login={login} />

      {/* 메인이미지 */}
      <Grid container width="100%" direction="column">
        {cid !== "CT14S15143839.Pdfg3" && (
          <Box
            sx={{
              width: "100%",
              height: "50px",
              background: "black",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img src={center.logo} height="35px" />
          </Box>
        )}
        <HomeNotice login={login} p_count={count} />
        <HomeLevel login={login} />
        {/* 메인 카테고리 */}
        <Grid
          // container
          position="relative"
          width="100%"
          // height="140px"
        >
          <Box
            sx={{
              width: "100%",
              // height: '100vh',
              // position: "absolute",
              // top: '-25px',
              background: "white",
              borderRadius: "15px 15px 0 0",
              marginTop: "-25px",
              // zIndex: 1,
            }}
          >
            <ResearchInfo login={login} />
            <EventCoupon
              login={login}
              homeClassCouponReload={homeClassCouponReload}
              loaded={loaded}
            />
            {login.mcd === "" ? null : cid === "CT17X10111035.huwy5" &&
              moment().format("YYYY-MM-DD") >= "2025-04-07" &&
              moment().format("YYYY-MM-DD") <= "2025-04-30" ? (
              <HomeCalorieGageBoostUp login={login} />
            ) : cid === "CID00000009" &&
              moment().format("YYYY-MM-DD HH:mm") >= "2025-04-08 07:00" &&
              moment().format("YYYY-MM-DD") <= "2025-04-30" ? (
              <HomeCalorieGageBoostUp login={login} />
            ) : (
              <HomeCalorieGage login={login} />
            )}

            {login.mcd !== "" && (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "10px 10px 0 0",
                }}
                onClick={() => setOpenMember(true)}
              >
                {membership <= 60 && (
                  <>
                    <Box
                      sx={{
                        fontFamily: "BebasNeue",
                        marginRight: "20px",
                        fontSize: "28px",
                        color: "#696969",
                      }}
                    >
                      My Level
                    </Box>
                    <Box
                      sx={{
                        fontFamily: "BebasNeue",
                        fontSize: "28px",
                        // background: 'linear-gradient(to bottom right, #696969, #c8c8c8, #696969)',
                        // backgroundClip: 'text',
                        // WebkitBackgroundClip: 'text',
                        // color: 'transparent',
                        color: "#696969",
                      }}
                    >
                      Silver
                    </Box>
                  </>
                )}

                {membership > 60 && (
                  <>
                    <Box
                      sx={{
                        fontFamily: "BebasNeue",
                        marginRight: "20px",
                        fontSize: "28px",
                        color: "#e4ac00",
                      }}
                    >
                      My Level
                    </Box>
                    <Box
                      sx={{
                        fontFamily: "BebasNeue",
                        fontSize: "28px",
                        // background: 'linear-gradient(to bottom right, #696969, #c8c8c8, #696969)',
                        // backgroundClip: 'text',
                        // WebkitBackgroundClip: 'text',
                        // color: 'transparent',
                        color: "#e4ac00",
                      }}
                    >
                      Gold
                    </Box>
                  </>
                )}
              </Box>
            )}

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                padding: "20px 10px 20px 10px",
                textAlign: "center",
              }}
            >
              {/* 클래스 쿠폰 */}
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <HomeCountClassCoupon
                  login={login}
                  ref={homeClassCoupontRef}
                ></HomeCountClassCoupon>
                <Box
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  클래스 쿠폰
                </Box>
              </Box>
              <Divider orientation="vertical" flexItem={true} />

              {/* PT 쿠폰 */}
              {center.pt_coupon_sale === true && (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HomeCountPTCoupon
                      login={login}
                      ref={homePTCoupontRef}
                    ></HomeCountPTCoupon>
                    <Box
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      PT 쿠폰
                    </Box>
                  </Box>
                  <Divider orientation="vertical" flexItem={true} />
                </>
              )}

              {/* 패스쿠폰 */}
              {showPassCoupon && (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      position: "relative",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <HomeCountPassCoupon
                      login={login}
                      ref={homePassCouponRef}
                    ></HomeCountPassCoupon>
                    <Box
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      패스 쿠폰
                    </Box>
                  </Box>
                  <Divider orientation="vertical" flexItem={true} />
                </>
              )}

              {/* 출석 프리퀀시 */}
              {cid !== "CT25Z16161026.irtu8" && (
                <Box
                  sx={{
                    width: "100%",
                    position: "relative",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <HomeCountFrequency
                    login={login}
                    frequencyClick={frequencyClick}
                  />
                  <Box
                    sx={{
                      fontSize: "14px",
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    출석 프리퀀시
                  </Box>
                </Box>
              )}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                textAlign: "center",
                padding: "0 10px 20px 10px",
              }}
            >
              {/* 심박포인트 */}
              <HomeHeartPoint login={login}></HomeHeartPoint>

              {/* 칼로리 */}
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box>
                  <HomeCountCalorie
                    login={login}
                    caloriePointClick={caloriePointClick}
                  />
                </Box>
                <Box
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  칼로리포인트
                </Box>
              </Box>
              <Divider orientation="vertical" flexItem={true} />

              {/* 캐시 */}
              <Box
                sx={{
                  width: "100%",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <HomeCountCash login={login} cashClick={cashClick} />
                <Box
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  캐시
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        <Grid
          container
          justifyContent="center"
          position="relative"
          sx={{ mt: 1 }}
        >
          {/* 달력 */}
          <HomeCalendar login={login} />
        </Grid>

        {/* What's New */}
        <WhatsNew ref={WhatsNewRef} login={login} />

        {/* 카드 심사용 앱 하단 정보 - 평소엔 미출력 */}
        {cid === "" && (
          <Box
            sx={{
              padding: "10px 20px",
              background: "black",
              color: "white",
              marginTop: "20px",
            }}
          >
            <Box sx={{ fontSize: "12px" }}>{center.address.address1}</Box>
            <Box sx={{ fontSize: "12px" }}>{center.address.address2}</Box>
            <Box sx={{ fontSize: "12px" }}>{center.address.address3}</Box>
          </Box>
        )}
        <HomeFooter />

        {/* 출입문열기 */}
        {showPassCoupon && <HomeDoor login={login}></HomeDoor>}

        {(loaded && (login.mcd === undefined || login.mcd === "")) ||
        count !== 0 ? (
          <Box height="140px" width="100%" className="bg-[#eaeef3]"></Box>
        ) : (
          <Box height="70px" width="100%" className="bg-[#eaeef3]"></Box>
        )}
      </Grid>
      <BottomButton login={login} loaded={loaded} style={{ zIndex: 500 }} />
      <BottomMenu active="home"></BottomMenu>
    </Grid>
  );
}

export default Home;
